import {
  DocSorterFileStatusEnum,
  GetAllFilesApiV1FilesGetData,
  ReportGeneratorTemplateResponseStatusEnum,
} from "@/api/generated/types.gen";
import { DOCUMENT_CLASSIFICATIONS } from "@/constants/documents";

export const DOCUMENT_TYPES_OPTIONS = DOCUMENT_CLASSIFICATIONS.map((item) => ({
  value: item.category,
  label: item.title,
}));

const statusList = (...statuses: DocSorterFileStatusEnum[]) => statuses.join(",");

// MDRS-520: the states a user can see (generating / done / failed), each sent
// as the comma-separated stored statuses behind it. Finished documents are
// stored as EXPORTED, so a raw "Completed" option never matched anything.
export const DOCUMENT_STATUS_OPTIONS: {
  value: string;
  label: string;
}[] = [
  { value: statusList("TO_BE_PROCESSED", "PROCESSING"), label: "Processing" },
  { value: statusList("COMPLETED", "EXPORTING", "EXPORTED"), label: "Completed" },
  { value: statusList("FAILED"), label: "Failed" },
];

export const REPORT_STATUS_OPTIONS: {
  value: ReportGeneratorTemplateResponseStatusEnum;
  label: string;
}[] = [
  { value: "TO_BE_PROCESSED", label: "To Be Processed" },
  { value: "PROCESSING", label: "Processing" },
  { value: "COMPLETED", label: "Completed" },
  { value: "FAILED", label: "Failed" },
];

export const SORTING_ORDER_OPTIONS: {
  value: NonNullable<GetAllFilesApiV1FilesGetData["query"]>["sort_by"];
  label: string;
}[] = [
  { value: "recently_added", label: "Recently Added" },
  { value: "recently_updated", label: "Recently Updated" },
  { value: "oldest", label: "Oldest" },
];
